var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wechatQr"},[_c('div',{staticClass:"tit"},[_vm._v("请打开微信扫一扫")]),_c('div',{staticClass:"qrBox"},[_c('img',{staticClass:"qrImg",attrs:{"src":_vm.dataQr}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }